module.exports = __webpack_public_path__ + "04_glasses_red.bde07fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer4/04_glasses_red.png
// module id = G+sz
// module chunks = 0